// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import vuetify from '@/plugins/vuetify'
import VueSession from 'vue-session'
import VueMask from 'v-mask'
import 'bootstrap/dist/css/bootstrap.css'
import vueXlsxTable from 'vue-xlsx-table'
import axios from 'axios'
// import moment from 'moment' // แปลง date
import moment from 'moment-timezone'

import Nl2br from 'vue-nl2br'
import VueSweetAlert from 'vue-sweetalert'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueRecaptcha from 'vue-recaptcha'
// import VueGtm from 'vue-gtm'

Vue.config.productionTip = false
// import store from './store'
// import Swal from 'sweetalert2'
// Vue.use(VueGtm, {
//   id: 'GTM-TK7ZPCD', // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
//   queryParams: {
//     // Add URL query string when loading gtm.js with GTM ID (required when using custom environments)
//     // gtm_auth: 'AB7cDEf3GHIjkl-MnOP8qr',
//     // gtm_preview: 'env-4',
//     // gtm_cookies_win: 'x'
//   },
//   defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
//   compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
//   nonce: '2726c7f26c', // Will add `nonce` to the script tag
//   enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
//   debug: true, // Whether or not display console logs debugs (optional)
//   loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
//   vueRouter: router, // Pass the router instance to automatically sync with router (optional)
//   ignoredViews: ['Login', 'EmClose', 'UserSubmit', 'ManageShop', 'rating', 'OnsiteRating', 'jobConfirm', 'Booking', 'BookingForm', 'BookingAddress', 'ConditionFlow', 'UserHistory', 'BookingQrcode', 'BookingField', 'Thank', 'PaymentUpload', 'ConfirmUser', 'CheckBookingLatest', 'CheckBookingNext'], // Don't trigger events for specified router names (optional)
//   trackOnNextTick: false // Whether or not call trackView in Vue.nextTick
// })

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCnDosnYWNnKQxLbsI5Cy_iw_VC5oyc1Ck',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    region: 'TH',
    language: 'th'
  },
  installComponents: true
})
Vue.config.productionTip = false
Vue.component('nl2br', Nl2br)
Vue.component('vue-recaptcha', VueRecaptcha)
Vue.use(VueSession)
Vue.use(VueSweetAlert)
Vue.use(VueRecaptcha)
Vue.prototype.$firebase = window.firebase

moment.tz.setDefault('Asia/Bangkok')

Vue.use(VueMask)
Vue.use(vueXlsxTable, {rABS: false})

Vue.prototype.$profile_dev = {
  'displayName': 'Pamorn Trivorrarat',
  'pictureUrl': 'https://profile.line-scdn.net/0heYkOVB2MOnZGNizwjMlECTZmORxlR2NkYlMmRXNhZhF8USomP1knFSZjN0N9ACh1OlR9QnozbBNKJU0QWGDGQkEGZEF_AXkpall0lQ',
  // 'pictureUrl': 'https://profile.line-scdn.net/0hehdTWCiWOkdZLRKhl6VFEGVoNCouAzwPIUl2JX4pNnQnSHsUMRx8dCgoNCUmTS1BMRhzKHQpMyN9',
  'statusMessage': 'ใช้ไลน์อันนี้นะคร้าบ',
  'userId': 'U94bf0e456831828c01fbff22fd808482'
  // 'userId': 'Uf99c8904e8fe03bfa1bd6e2f06ab5405'
  // 'userId': 'U7e42e5d8e594381c476f1390a215b8fc'
  // Uec015abe09c4b00b0dfd25dc882866f4 - GOT
  // 'userId': 'Ubb981ed38ad6dd18734560d2203df255'
}

Vue.prototype.$weburl = 'https://betask-linked.web.app/'
// Vue.prototype.$liffId = '1655981910-KjVRlgdb'
Vue.prototype.$liffIdMain = '1656581804-7KRQyqo5'
Vue.prototype.$liffIdForm = '1656581804-32mk7OgE'
Vue.prototype.$liffIdFormEmp = '1656581804-b09WBwkP'
Vue.prototype.$liff = window.liff
// Vue.prototype.$omise_public_key = 'pkey_test_5whiufc1mlwlxlql1rr'
Vue.prototype.$OmiseCard = window.OmiseCard

Vue.config.productionTip = false
Vue.mixin({
  computed: {
    themeStyle: {
      get: function () {
        return {
          '--color_headline1': this.master_theme['color1'],
          '--color_subheadline1': this.master_theme['color3'],
          '--color_icon1': this.master_theme['color2'],
          '--color_headline2': this.master_theme['color4'],
          '--color_subheadline2': this.master_theme['color5'],
          '--color_icon2': this.master_theme['color6'],
          '--color_picture': this.master_theme['color7'],
          '--coin_img': "url('/static/img/coin.svg')"
        }
      },
      set: function (newValue) {
        this.master_theme = newValue
      }
    }
  },
  data: function () {
    return {
      shopNameData: {
        // atFavorite = Motta shop
        atFavorite: 'U0c232da5722cb2b5a650c196f89ae797',
        creativeliveidea: 'U543e0cfdac298365dbe4cb3a41ed6fd4',
        airmate: 'U59422b6ffb95aea0fd17b0b79bcc9895',
        onsitebBetaskSignature: 'Ue769a7b0e8b967b573f763eaba3ab70b',
        ayasan: 'U61a07d2a464114354571a25defb8789a',
        assa: 'Uded6fe88c383ca08639135cd5844afe2',
        numchai: 'U2537f5c842f9c075ea23d57edfc51459',
        themall: 'U3e16601f14a37a066d00cecbb4b8394c',
        cJAutoGallery: 'Ucd348d8b9a2bfc005c95ba4db59c4eb4',
        englishMunmun: 'Ub7cbc419244731cdd682354dd0e57cef',
        englishMunmunCoppyTest: 'Ua214787f52cd3f62110a4917f3c21407',
        Vela: 'U5febfe1716555403fb9073cff3b2fb84',
        ECommerceExpo: 'SD_1759389571804',
        Doctor: 'U37e025cb907bb4a94345ec28698d794d',
        kungsri: 'Ubb80127ad92f4b69686a9a5a7aabd463',
        showDate: 'SD_1659673973416xx',
        showDate1: 'SD_1751720454917',
        krungthaiWesternHospital: 'SD_1760436097862',
        krungthaiWesternHospitalPkm: 'Uef6c98c8dd77361b52bdce5e8a019b14',
        testDriveGeely: 'U849582b67d89c975c83e37055175da45',
        samitivej: 'U99efe4a4ce6c50944e6f65020c91ad21',
        centralPattana: 'Ub97e53a50d6d1805d188df50e83b1a53',
        officeOmbudsman: 'Uc1107ca5ad523dddf958cf92c78c85de',
        wonderfruitTaxi: 'Uef33e2271382f6c1dcfc56f4f7d11d59',
        yamaha: 'U0f47529d9b295da15c3961d1a175c1e0'
      },
      master_theme: {
        'color1': '',
        'color2': '',
        'color3': '',
        'color4': '',
        'color5': '',
        'color6': '',
        'color7': ''
      },
      globalVar: 'global',
      DNS_IP: '',
      DNS_IP_Loyalty: '',
      ADMIN_IP: '',
      PK: '', // Primary Key
      ApplicationKey: '', // Token
      // IPPotocalENV_Production: 'https://pretest-api-popmart.betaskthai.com',
      IPPotocalENV_Production: 'https://api-belinked.betaskthai.tech',
      IPPotocalENV_ProductionLoyalty: 'https://api-beloyalty-productions.betaskthai.tech',
      IPPotocalENV_Developer: 'http://localhost',
      IPPotocalENV_DeveloperLoyalty: 'http://localhost:5001',
      ADMIN_URL_Production: 'https://betask-linked.web.app/',
      ADMIN_URL_Developer: 'http://localhost',
      profile: {
        userId: '',
        displayName: '',
        pictureUrl: '',
        statusMessage: ''
      },
      member: null
    }
  },
  async mounted () {
    if (process.env.NODE_ENV === 'development') {
      // this.DNS_IP = this.IPPotocalENV_Developer + ':5005'
      this.DNS_IP = this.IPPotocalENV_Production
      // this.DNS_IP = 'https://ea52-2001-fb1-3a-380e-8407-b534-4a34-958b.ngrok-free.app'
      this.ADMIN_IP = this.ADMIN_URL_Developer + ':8080'
      this.DNS_IP_Loyalty = this.IPPotocalENV_ProductionLoyalty
    } else {
      this.DNS_IP = this.IPPotocalENV_Production
      this.ADMIN_IP = this.ADMIN_URL_Production
      this.DNS_IP_Loyalty = this.IPPotocalENV_ProductionLoyalty
    }
  },
  methods: {
    notAcceptedPDPA (languageSelect) {
      this.$router.push('/Thank?shopId=' + this.shopId + '&redirectBy=notAcceptedPDPA&languageSelect=' + languageSelect)
    },
    updateNewBookingFibase (dataShopId) {
      let params = {
        shopId: dataShopId
      }
      axios.post('https://asia-southeast1-be-linked-a7cdc.cloudfunctions.net/BetaskNotify-ProcessBookingNew', params)
    },
    async checkBanUserId (userId, shopId) {
      let datacheckBanUserId = false
      await axios.get(this.DNS_IP + '/member/get?shopId=' + shopId + '&liffUserId=' + userId).then(response => {
        let rs = response.data
        console.log('checkBanUserId', rs)
        if (rs.status !== false) {
          let dataCheck = rs[0].banStatus || 'False'
          if (dataCheck === 'False') {
            datacheckBanUserId = false
          } else {
            datacheckBanUserId = true
            this.$swal({
              title: '',
              type: 'warning',
              html: '<p>บัญชีของท่านถูกระงับการใช้งานชั่วคราว \n โปรดติดต่อเจ้าหน้าที่</p><p>Your account has been temporarily suspended. \n Please contact customer support for assistance.</p>',
              showConfirmButton: false,
              allowOutsideClick: false,
              allowEscapeKey: false
            })
          }
        } else {
          datacheckBanUserId = false
        }
      }).catch((error) => {
        console.log(error)
        datacheckBanUserId = false
      })
      console.log('datacheckBanUserId', datacheckBanUserId)
      return datacheckBanUserId
    },
    async getDataLineConfig (shopId) {
      let dataLineConfig = []
      await axios.get(this.DNS_IP + '/lineconfig/get?shopId=' + shopId).then(response => {
        let rs = response.data
        console.log('getDataLineConfig shopId', shopId)
        console.log('getDataLineConfig', rs)
        if (rs.status === false) {
          dataLineConfig = {
            liffMainID: '1656581804-7KRQyqo5',
            liffBookingFormID: '1656581804-32mk7OgE',
            liffBookingFormEmpID: '1656581804-b09WBwkP',
            checkConfig: false
          }
        } else {
          dataLineConfig = rs[0]
        }
      }).catch((error) => {
        console.log(error)
        dataLineConfig = {
          liffMainID: '1656581804-7KRQyqo5',
          liffBookingFormID: '1656581804-32mk7OgE',
          liffBookingFormEmpID: '1656581804-b09WBwkP',
          checkConfig: false
        }
      })
      return dataLineConfig
    },
    async getProfileAccess (token) {
      let result = null
      await axios({
        method: 'get',
        headers: {
          accessToken: token
        },
        url: this.DNS_IP + '/line/getProfileByAccess'
      }).then((response) => {
        result = response.data
      }).catch((error) => {
        console.log(error)
        result = null
      })
      return result
    },
    async callBeTaskAPI (method, url, params) {
      let result = null
      console.log(url)
      const token = await this.$liff.getAccessToken() || '1234567890'
      // console.log(this.liffId)
      // console.log(token)
      var userIdUse = ''
      if (this.profile.userId === '') {
        userIdUse = await this.getProfileAccess(token)
        this.profile.userId = userIdUse.userId
      }
      console.log(this.$session.get('shopId'))
      await axios({
        method: method,
        headers: {
          shopId: this.$session.get('shopId'),
          lineUserId: this.profile.userId,
          lineId: this.profile.userId
        },
        url: this.DNS_IP + url,
        data: params
      }).then((response) => {
        result = response.data
      }).catch((error) => {
        console.log(error)
        result = null
      })
      return result
    },
    // async checkLiffLogin () {
    //   console.log('checkLiffLogin', this.$liffId)
    //   await this.$liff.init({
    //     liffId: this.$liffId
    //   }).then(async () => {
    //     await this.getProfileMain(this.$liffId)
    //   }).catch((err) => {
    //     // this.$router.push({ name: '404' })
    //     console.log(err.code, err.message)
    //   })
    //   // this.$liff.init({ 'liffId': liffId }, function (data) {})
    // },
    // async getProfileMain () {
    //   await this.$liff.ready.then(async () => {
    //     if (process.env.NODE_ENV === 'development') {
    //       this.getProfile_dev()
    //     } else {
    //       if (!this.$liff.isLoggedIn()) {
    //         this.$liff.login({redirectUri: `${this.$weburl}?liffId=${this.$liffId}`})
    //       } else {
    //         await this.getProfile()
    //       }
    //     }
    //   })
    // },
    // async getProfile () {
    //   let _this = this
    //   await this.$liff.getProfile().then(function (profile) {
    //     _this.profile = profile
    //     console.log('prod', _this.profile)
    //   }).catch(function (error) {
    //     console.log('Error getting profile: ' + error)
    //   })
    // },
    // getProfile_dev () {
    //   this.profile = this.$profile_dev
    //   console.log('dev', this.profile)
    // },
    formatNumber (value) {
      if (value && value !== 0) {
        console.log('valuevalue', value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      } else {
        return 0
      }
    },
    format_date (value) {
      if (value) {
        return moment(String(value)).format('DD/MM/YYYY HH:mm')
      }
    },
    format_date1 (value) {
      if (value) {
        return moment(String(value)).format('DD/MM/YYYY') + ' เวลา ' + moment(String(value)).format('HH:mm') + 'น.'
      }
    },
    format_date2 (value) {
      if (value) {
        return moment(String(value)).format('YYYY-MM-DD HH:mm')
      }
    },
    // YYYY-MM-DD
    momenDate_1 (value) {
      if (value) {
        return moment(String(value)).format('YYYY-MM-DD')
      }
    },
    momenTime (value) {
      if (value) {
        return moment(String(value)).format('HH:mm')
      }
    },
    momenDate_2 (value) {
      if (value) {
        return moment(String(value)).format('DD-MM-YYYY')
      }
    },
    momenDate_3 (value) {
      if (value) {
        return moment(String(value)).format('DD MMM YYYY')
      }
    },
    momenDate_4 (value) {
      if (value) {
        return moment(String(value)).format('MMM YYYY')
      }
    },
    momenDate_YYYY (value) {
      if (value) {
        return moment(String(value)).format('YYYY')
      }
    },
    momenDate_MM (value) {
      if (value) {
        return moment(String(value)).format('MM')
      }
    }
  }
})

function updatePageTitle (to, from) {
  const { title, icon } = to.meta
  const pageTitleElement = document.getElementById('page-title')
  if (pageTitleElement) {
    pageTitleElement.innerText = title || 'Betask Linked'
  }

  const favicon = document.querySelector('link[rel="shortcut icon"]')
  favicon.setAttribute('type', 'image/x-icon')
  favicon.setAttribute(
    'href',
    icon || 'https://betaskthai.com/wp-content/uploads/2020/03/cropped-LOGO_BeTask-website2.png'
  )
}

router.beforeEach((to, from, next) => {
  updatePageTitle(to, from)
  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  vuetify,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js